export const UI_COMPONENTS_MEMBERS_FORM_PATH_TRANSLATION_KEY = 'ui.members.components.form';
